import {createSelector} from 'reselect';
import {DeviceType} from '../../incase-domain/common/DeviceType.enum';
import {IPresentation} from '../../incase-domain/presentation';
import {IGameConfig} from '../../incase-domain/proptypes/gameConfig';
import {ISlidePreview} from '../../incase-domain/proptypes/slidePreview';
import {ISlide} from '../../incase-domain/slide';
import {filterSlideTypes} from '../../util/slide.utils';
import {AppState} from '../reducer';
import {SequenceQueueEntry} from '../reducer/presentation.reducer';

export const loadedPresentationSelector = (state: AppState): IPresentation | undefined => state.presentationReducer.loadedPresentation;
export const gameConfigSelector = (state: AppState): IGameConfig | undefined => state.presentationReducer.loadedPresentation?.gameConfig;

export const currentSlideIndexSelector = (state: AppState): number => state.presentationReducer.currentSlideIndex;
export const slideIndexListSelector = (state: AppState): string[] => state.presentationReducer.loadedPresentation?.slideIndexList || [];
export const lastShowedSlideSelector = (state: AppState): number => state.presentationReducer.lastShowedSlide;
export const presentationStatusSelector = (state: AppState): {found: boolean; id: string} => state.presentationReducer.presentationStatus;
export const hasSlidesSelector = (state: AppState): boolean => state.presentationReducer.hasSlides;
export const gameClockSelector = (state: AppState): number | undefined =>
    state.presentationReducer.loadedPresentation?.gameConfig.gameClock;
export const clickedElementIdsSelector = (state: AppState): string[] => state.presentationReducer.clickedElementIds;
export const drawEnabledSelector = (state: AppState): boolean => state.presentationReducer.drawEnabled;
export const redrawFlagSelector = (state: AppState): boolean => state.presentationReducer.redrawFlag;
export const askToEndPresentationModuleSelector = (state: AppState): boolean => state.presentationReducer.askToEndPresentationModule;
export const presentationPreviewsSelector = (state: AppState): ISlidePreview[] => state.presentationReducer.presentationPreviews;
export const presLoadingStateSelector = (state: AppState): number => state.presentationReducer.presLoadingState;
export const scaleSelector = (state: AppState): number => state.presentationReducer.scale;
export const arrowsDisabledSelector = (state: AppState): boolean => state.presentationReducer.arrowsDisabled;
export const activeMobileQuestionSelector = (state: AppState): string => state.presentationReducer.activeMobileQuestionId;

export const visibleSlideSelector = createSelector(
    (state: AppState) => state.presentationReducer.loadedPresentation?.slides,
    (state: AppState) => state.layoutReducer.selectedDeviceType,
    (slides: ISlide[] | undefined, selectedDeviceType: DeviceType): ISlide[] | undefined => {
        const visible = slides?.filter((slide: ISlide) => !slide.hidden) || [];
        const deviceTypes = [DeviceType.ALL, selectedDeviceType];
        return filterSlideTypes(visible, deviceTypes);
    }
);

export const preventClickToNextSlideSelector = (state: AppState): boolean | undefined => state.presentationReducer.preventClickToNextSlide;

export const sequenceQueueSelector = (state: AppState): SequenceQueueEntry[] => state.presentationReducer.sequenceQueue;
export const activeSequenceStepSelector = (state: AppState): SequenceQueueEntry | null => state.presentationReducer.activeSequenceStep;
